import React , {Component} from 'react';
import '../../assets/scss/style.css';
import '../../assets/css/id.css';
import './post.css'; 

class Share extends Component {
   
    render(){
       
        return( 
            <div className=" sh b-r share"> 
              
            
            </div>
        )}}
 
export default Share